<script setup>
import Paginator from "@/Components/Blocks/ProductOverview/Paginator.vue";
import BlogCard from "@/Components/Blog/BlogCard.vue";
import {useForm, usePage} from "@inertiajs/vue3";

const props = defineProps({
  query: Object,
  blogs: Object,
});

const form = useForm({
  page: props.query.page ?? 1,
});

const getData = (page = 1) => {
  form.page = page;

  form.get(usePage().props.route.current, {
    preserveState: true,
  });
};


</script>

<template>
    <div class="container mb-15 mt-8 md:mb-30">
        <div
            :class="{'opacity-30':form.processing}"
            class="grid grid-cols-2 gap-8 transition-opacity sm:grid-cols-3 md:gap-10 lg:grid-cols-3 2xl:gap-16"
        >
            <div
                v-for="blog in blogs.data"
                :key="blog.id"
                class="relative"
            >
                <BlogCard
                    :blog="blog"
                />
            </div>
        </div>
        <Paginator
            class="pb-2 md:flex"
            :data="blogs"
            @set-page="getData"
        />
    </div>
</template>


